/* app/ui/form/validate */

define(
	'app/ui/form/validate',[
		'jquery'
	],

	function ( $ ) {

		var Validate;
		var $formToValidate;
		var $submitButton;
		var $regExInputs;
		var $requiredInputs;
		var hasSubmitted = false;
		var errorClass = 'has-error';
		var selectors = {
			field: '.form-fields > li',
			errorMessage: '.error-message',

			required: '[required], [data-val-required]',
			regEx: '[data-val-regex-pattern]'
		};
		var defaultMessage = 'This field is required';
		var emailPattern = new RegExp( "[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?" );

		return {

			init: function () {
				Validate = this;
				$formToValidate = $('.js-validate-form');
				$submitButton = $formToValidate.find('.js-submit');
				$regExInputs = $formToValidate.find(selectors.regEx);
				$requiredInputs = $formToValidate.find(selectors.required);

				$submitButton.on('click', Validate._processSubmitClick);
				$formToValidate.on('submit', Validate._validateForm);
				$requiredInputs.on('change', Validate._processChange);
			},

			_validateForm: function () {
				var allValid = true;
				var errorFields = [];

				$requiredInputs.add($regExInputs).each(function(){
					var $thisInput = $(this);
					var field = $thisInput.closest(selectors.field);
					var isValid = Validate._validateInput($thisInput);
					if(!isValid){
						allValid = false;
						errorFields.push(field);
					}
				});

				if(errorFields.length){
					Validate._scrollToElm(errorFields[0]);
					if(!hasSubmitted){
						$requiredInputs.on('keyup', Validate._processChange);
					}
				}
				hasSubmitted = true;
				return allValid;
			},

			_processSubmitClick: function (e) {
				e.preventDefault();
				$formToValidate.submit();
			},

			_processChange: function () {
				var $thisInput = $(this);
				var field = $thisInput.closest(selectors.field);

				Validate._validateInput($thisInput);
			},

			_clearError: function ($thisField) {
				$thisField.removeClass(errorClass);
				$thisField.find(selectors.errorMessage).remove();
			},
			_setError: function ($thisField, message) {
				message = message || defaultMessage;
				$thisField.addClass(errorClass);
				var errorSpan = $('<span />').addClass(selectors.errorMessage.substr(1)).text(message);
				$thisField.append(errorSpan);
			},

			_validateInput: function ($thisInput) {
				var valid = true,
					requiredValid = true,
					regExValid = true,
					field = $thisInput.closest(selectors.field);

				Validate._clearError(field);
				if ($thisInput.is(selectors.required)) {
					if(!$thisInput.is('[type="radio"]')){

						var value = $.trim($thisInput.val());
						if(value === ""){
							valid = false;
							requiredValid = false;
						}
						if($thisInput.is('[type="email"]')){
							if(!emailPattern.test(value))
							{
								valid = false;
								requiredValid = false;
							}
						}


					} else{
						var radioName = $thisInput.attr('name');
						var otherRadios = $formToValidate.find('[name="'+radioName+'"]');
						if(!otherRadios.filter(':checked').length){
							valid = false;
							requiredValid = false;
						}
					}

					if (!requiredValid) {
						Validate._setError(field, $thisInput.attr('data-val-required'));
					}
				}

				if (requiredValid) {
					if ($thisInput.is(selectors.regEx)) {
						var pattern = new RegExp($thisInput.attr('data-val-regex-pattern'));

						if (!pattern.test($thisInput.val())) {
							regExValid = false;
							valid = false;
						}

						if (!regExValid) {
							Validate._setError(field, $thisInput.attr('data-val-regex'));
						}
					}
				}

				return valid;
			},
			_scrollToElm: function(elm){
				var scrollHeight = elm.offset().top;
				var top = $("body").scrollTop();
				var bottom = top + $(window).height();
				if(scrollHeight < top || scrollHeight > bottom ){
					$("html, body").animate({ scrollTop: scrollHeight }, 300);
				}

			}

		};

	}
);
